module.exports = __webpack_public_path__ + "img/code-bottom-mobile.7beb1fb5.png";